import { inject } from 'vue'

type Options = { message: string };
type KlossToastType = {
    success: (options: Options) => void,
    error: (options: Options) => void,
    info: (options: Options) => void,
};

export const useKlossToast = () => {
  const ksToast = inject<KlossToastType>('ksToast')

  if (!ksToast) {
    throw new Error('ksToast not provided')
  }

  const success = (message: string) => {
    ksToast.success({ message })
  }

  const error = (message: string) => {
    ksToast.error({ message })
  }

  const info = (message: string) => {
    ksToast.info({ message })
  }

  return {
    success,
    error,
    info
  }
}
